import {
    useEffect,
    useRef,
} from "react";

import {
    useNavigate,
} from "react-router-dom";

import {
    toast,
} from "sonner";

import Layout from "@/components/Layout";

import {
    useAuth,
} from "@/contexts/AuthContext";


export default function BecomeSeller() {
    const {
        user,
        loading,
        becomeSeller,
    } = useAuth();

    const navigate =
        useNavigate();

    const started =
        useRef(false);


    useEffect(() => {
        if (
            loading
            || started.current
        ) {
            return;
        }

        started.current = true;

        const openSellerFlow =
            async () => {
                if (!user) {
                    navigate(
                        "/register",
                        {
                            replace: true,
                        }
                    );

                    return;
                }

                if (
                    user.role
                    === "seller"
                ) {
                    const approved =
                        user.seller_status
                            === "approved"
                        && user.seller_verified
                            === true;

                    navigate(
                        approved
                            ? "/seller"
                            : "/seller/verification",
                        {
                            replace: true,
                        }
                    );

                    return;
                }

                if (
                    user.role
                    !== "customer"
                ) {
                    navigate(
                        "/",
                        {
                            replace: true,
                        }
                    );

                    return;
                }

                try {
                    const updated =
                        await becomeSeller();

                    const approved =
                        updated.seller_status
                            === "approved"
                        && updated.seller_verified
                            === true;

                    navigate(
                        approved
                            ? "/seller"
                            : "/seller/verification",
                        {
                            replace: true,
                        }
                    );

                } catch (err) {
                    toast.error(
                        err.response?.data?.detail
                        || err.message
                        || "Could not start seller registration"
                    );

                    navigate(
                        "/",
                        {
                            replace: true,
                        }
                    );
                }
            };

        openSellerFlow();

    }, [
        loading,
        user,
        becomeSeller,
        navigate,
    ]);


    return (
        <Layout>
            <div className="min-h-[55vh] grid place-items-center">
                <div className="text-center">
                    <div className="animate-pulse text-muted-foreground">
                        ...
                    </div>
                </div>
            </div>
        </Layout>
    );
}
